import React, { useState, useEffect } from "react";
import {SinhalaData, EnglishData, TamilData} from  "./../../../../dummyData/handbookDummyData";
import { useSelector } from "react-redux";
import PDFViewerImage105 from "../../../../assets/PDFViewerImages/PDFViewerImage105.jpg";


const Chapter27 = () => {
    const selectedLanguage = useSelector((state) => state.language.language);
  const [language, setLanguage] = useState(SinhalaData[0]);

    useEffect(() => {
        switch (selectedLanguage.value) {
          case "english":
            setLanguage(EnglishData[0]);
            break;
          case "tamil":
            setLanguage(TamilData[0]);
            break;
          default:
            setLanguage(SinhalaData[0]);
            break;
        }
      }, [selectedLanguage]);

    return (
        <>
                 {/* Chapter 27 */}
                <section id="section27" className="drivers-handbook-section">
                    <h2 className="drivers-handbook-heading">{language.chapter27Title}</h2>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter27Paragraph1}
                    </p>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter27Paragraph2}

                    </p>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter27Paragraph3}
                    </p>

                    <div className="image-box">
                        <img src={PDFViewerImage105} alt="Traffic Rules"/>
                    </div>


                    <p className="drivers-handbook-paragraph">
                        {language.chapter27Paragraph4}

                    </p>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter27Paragraph5}

                    </p>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter27Paragraph6}
                    </p>

                    <ol className="drivers-handbook-list">
                        <li>{language.chapter27List11}</li>
                        <li>{language.chapter27List12}</li>
                        <li>{language.chapter27List13}</li>
                        <li>{language.chapter27List14}</li>
                    </ol>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter27Paragraph7}
                    </p>
                    <ul className="drivers-handbook-list">
                        <li>{language.chapter27List2}</li>
                        <ul className="drivers-handbook-list">
                            <li>{language.chapter27List31}</li>
                            <li>{language.chapter27List31}</li>
                        </ul>
                        <li>{language.chapter27List4}</li>
                        <ul className="drivers-handbook-list">
                            <li>{language.chapter27List51}</li>
                            <li>{language.chapter27List52}</li>
                            <li>{language.chapter27List53}</li>
                        </ul>
                    </ul>
                </section>

        </>
    )

}

export default Chapter27;
